export default {
    SET(state, data) {
        state[data.key] = data.value;
    },
};
